(() => {
  'use strict';
  const initialized = new WeakSet();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-ids-gallery]').forEach(gallery => {
      if (initialized.has(gallery)) return;
      const viewport = gallery.querySelector('[data-ids-gallery-viewport]');
      const slides = Array.from(gallery.querySelectorAll('[data-ids-gallery-slide]'));
      const dots = Array.from(gallery.querySelectorAll('[data-ids-gallery-dot]'));
      const previous = gallery.querySelector('[data-ids-gallery-prev]');
      const next = gallery.querySelector('[data-ids-gallery-next]');
      const status = gallery.querySelector('[data-ids-gallery-status]');
      const messages = JSON.parse(gallery.querySelector('[data-ids-gallery-messages]').textContent);
      if (!viewport || !slides.length || !previous || !next || !status) return;
      initialized.add(gallery);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let visible = 1;
      let maxIndex = slides.length - 1;
      let scrollTimer;
      let frame;
      const format = (template, first, last) => template.replaceAll('__FIRST__', String(first)).replaceAll('__LAST__', String(last)).replaceAll('__TOTAL__', String(slides.length));
      function update() {
        previous.disabled = current === 0;
        next.disabled = current === maxIndex;
        status.textContent = format(visible === 1 ? messages.single : messages.range, current + 1, Math.min(current + visible, slides.length));
        dots.forEach((dot, index) => {
          dot.hidden = index > maxIndex;
          dot.setAttribute('aria-current', String(index === current));
          dot.setAttribute('aria-label', format(messages.goto, index + 1, Math.min(index + visible, slides.length)));
        });
      }
      function go(index, immediate = false) {
        current = Math.max(0, Math.min(maxIndex, index));
        viewport.scrollTo({ left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: immediate || reduceMotion.matches ? 'auto' : 'smooth' });
        update();
      }
      function measure() {
        const gap = Number.parseFloat(window.getComputedStyle(gallery.querySelector('.ids-h-gallery__track')).gap) || 0;
        const width = slides[0].getBoundingClientRect().width;
        if (!width || !viewport.clientWidth) return;
        visible = Math.max(1, Math.min(slides.length, Math.floor((viewport.clientWidth + gap + 2) / (width + gap))));
        maxIndex = slides.length - visible;
        go(Math.min(current, maxIndex), true);
      }
      previous.addEventListener('click', () => go(current - 1));
      next.addEventListener('click', () => go(current + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
      viewport.addEventListener('keydown', event => {
        if (event.target !== viewport) return;
        const targets = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: maxIndex };
        if (!Object.hasOwn(targets, event.key)) return;
        event.preventDefault();
        go(targets[event.key]);
      });
      viewport.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const distance = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 1;
          current = Math.max(0, Math.min(maxIndex, Math.round(viewport.scrollLeft / distance)));
          update();
        }, 100);
      }, { passive: true });
      const resize = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(measure);
      };
      let observer;
      if ('ResizeObserver' in window) {
        observer = new window.ResizeObserver(resize);
        observer.observe(viewport);
      } else window.addEventListener('resize', resize);
      const section = gallery.closest('[id^="shopify-section-"]');
      if (section) section.addEventListener('shopify:section:unload', () => {
        observer?.disconnect();
        window.removeEventListener('resize', resize);
        window.clearTimeout(scrollTimer);
        window.cancelAnimationFrame(frame);
      }, { once: true });
      gallery.querySelector('[data-ids-gallery-controls]').hidden = false;
      gallery.querySelector('[data-ids-gallery-footer]').hidden = false;
      measure();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
